import Cookies from 'js-cookie';

let Banner = {
    init: () => {
        handleBannerMsg();
    }
}

const handleBannerMsg = () => {
    let bannerMsg =  $('[data-bind="bannermessage"]'),
        bannerMsgClose = bannerMsg.find('[data-bind="close"]'),
        navContainer = $('.nav-container'),
        headerBanner = $('.header-banner'),
        carouselBanner = $('.carousel-banner'),
        sectionHeader = $('.section-header'),
        sideBar = $('.nav-sidebar');

    bannerMsgClose.on('click', function(e) {
        e.stopPropagation();
        Cookies.set('bannermessage', 'accepted', {expires: 30});
        navContainer.addClass('no-banner');
        sideBar.removeClass('with-banner');
        sectionHeader.removeClass('section-header-with-banner');
        headerBanner.remove();
        carouselBanner.remove();
    });

    Cookies.get('bannermessage') === 'accepted' ? bannerMsg.remove() : '';

    if ($(".header-banner")[0] || $(".carousel-banner")[0]){
        navContainer.removeClass('no-banner');
        sectionHeader.addClass('section-header-with-banner');
    } else {
        sectionHeader.removeClass('section-header-with-banner');
    }

    navContainer.hasClass('no-banner') ? sideBar.removeClass('with-banner') : '';
}

export default Banner;
